import { render } from "./Showcase.vue?vue&type=template&id=5ac56025"
import script from "./Showcase.vue?vue&type=script&lang=js"
export * from "./Showcase.vue?vue&type=script&lang=js"

import "./Showcase.vue?vue&type=style&index=0&id=5ac56025&lang=css"
script.render = render

export default script